// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2i4vq","controls":"styles_controls__1ISHh","charLimit":"styles_charLimit__cHvVi","input":"styles_input__2lv8Z","send":"styles_send__2ic48"};